/**
 * 未登录游客货币偏好（localStorage）。
 * 已登录一律以账号资料为准，登录成功后清掉本地。
 * 国内站切换仍强制 CNY（与原 change_userInfo 行为一致）。
 */
import { IS_CHINA } from '@/config'

const GUEST_CURRENCY_KEY = 'preferred_currency'

export function getGuestCurrency() {
  const raw = localStorage.getItem(GUEST_CURRENCY_KEY)
  if (!raw) return ''
  return String(raw).trim().toUpperCase()
}

export function setGuestCurrency(code) {
  const normalized = IS_CHINA ? 'CNY' : String(code || '').trim().toUpperCase()
  if (!normalized) {
    removeGuestCurrency()
    return ''
  }
  localStorage.setItem(GUEST_CURRENCY_KEY, normalized)
  return normalized
}

export function removeGuestCurrency() {
  localStorage.removeItem(GUEST_CURRENCY_KEY)
}

/**
 * 未登录且本地有偏好时，才带给价目接口的 currency；已登录不传（后端忽略也不必传）。
 */
export function getRequestCurrency({ isLogin } = {}) {
  if (isLogin) return undefined
  if (IS_CHINA) return undefined
  const code = getGuestCurrency()
  return code || undefined
}
